'use client';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useMapContext } from '../../../contexts/map-context';
import useLandMap from '../../../hooks/useLandMap';
import Image from 'next/image';
import { useAccount } from 'wagmi';
import { puppyNetChainId, shibariumChainId } from '../../../constants';

/* styled elements */
const FilterPanel = styled.div<{ isexpanded: string }>`
    background: #130F0FCC;
    border: 1px solid #D4D4D4;
    box-sizing: border-box;
    border-radius: 8px;
    width: 300px;
    height: ${({ isexpanded }) => (isexpanded === 'true' ? 'auto' : '45')}px;
    transition: all .5s;
    position: absolute;
    top: 8rem;
    left: 2rem;
    z-index: 5;
    font-size:16px;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0.5rem 1rem;
    overflow: hidden;
`;

const FilterHeader = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

const Title = styled.div`
    font-weight: 700;
    font-size: 16px;
    line-height: 24px;
    text-align: center;
    color: #FFF;
`;

const FilterActions = styled.div`
    display: flex;
    flex-direction: row;
    gap: 2rem;
`;

const ClearIcon = styled.div`
    width: 18px;
    margin-right: 10px;

    &:hover {
        cursor: pointer;
    }
`;

const ExpandIcon = styled.div`
  cursor: pointer;
`;

const FilterContent = styled.div`
    display: flex;
    flex-direction: column;
    padding: 1rem 0;
    padding-bottom: .5rem;
    color: white;
`;

const BridgeWrapper = styled.div`
    padding: 1rem 0;
    border-top: 0.5px solid #FFF;
    width: 100%;
`;


export const MapFilter = () => {
    const [expand, setExpand] = useState(true);
    const { state, dispatch } = useMapContext();
    const { address, chain } = useAccount()

    const [filterData, setFilterData] = useState([
        {
            color: '#FFFFFF',
            borderColor: '#F38F2E',
            text: 'Shiboshis Zone',
            searchOption: 'shiboshiZone'
        },
        {
            color: '#FF6600',
            text: 'Diamond Teeth',
            searchOption: 'diamond'
        },
        {
            color: '#6EA833',
            text: 'Platinum Paw',
            searchOption: 'platinum'
        },
        {
            color: '#B4CC9C',
            text: 'Golden Tail',
            searchOption: 'gold'
        },
        {
            color: '#768766',
            text: 'Silver Fur',
            searchOption: 'silver'
        },
    ]);




    const setSearchOptions = (newOptions: any) => dispatch({ type: 'UPDATE_SEARCH_OPTIONS', payload: { newOptions } });

    const setSearchOption = (option: string) => {
        const newOptions = { ...state.searchOptions };
        newOptions[option] = !newOptions[option];
        setSearchOptions(newOptions);
    };


    const handleClearFilters = () => {
        const newOptions = {
            shiboshiZone: false,
            privatehub: false,
            diamond: false,
            platinum: false,
            gold: false,
            silver: false,
            openforbid: false,
            minPos: {
                x: null,
                y: null,
            },
            maxPos: {
                x: null,
                y: null,
            },

            walletAddress: '',

            clearFilters: true
        };

        setSearchOptions(newOptions);
    };


    return (
        <FilterPanel isexpanded={expand.toString()}>
            <FilterHeader>
                <Title>FIND YOUR LAND</Title>
                <FilterActions>
                    <ClearIcon onClick={handleClearFilters}>
                        <button className="flex items-center justify-center w-full rounded-full border border-1 border-white/50 bg-black/50  px-6 py-0.5  sm:px-6 sm:py-0.5 text-center text-xs md:text-sm font-semibold text-white shadow-lg hover:bg-black focus:outline-none">Clear</button>
                    </ClearIcon>
                    <ExpandIcon onClick={() => setExpand(prev => !prev)}>
                        {expand ? <Image src={'/images/chevron-up-black.png'} alt="Selected Icon" width={25} height={25} /> : <Image src={'/images/chevron-down-black.png'} alt="Selected Icon" width={25} height={25} />}
                    </ExpandIcon>
                </FilterActions>
            </FilterHeader>

            <FilterContent className='w-full text-white font-quicksand'>
                Zones
                {filterData.map((item, index) => (
                    <div
                        className={`flex items-center cursor-pointer mb-2  rounded-lg text-white transition duration-200`}
                        key={`filter ${index}`}
                        onClick={() => {
                            setSearchOption(item.searchOption)
                        }}
                    >
                        <div className="flex items-center justify-center mr-2">
                            <button className={`border bg-white hover:opacity-80 w-5 h-5 flex items-center justify-center`}>
                                {state.searchOptions[item.searchOption] && (
                                    <Image src={'/images/map/icons/check.svg'} alt="Selected Icon" width={18} height={18} />
                                )}
                            </button>
                        </div>
                        <div
                            className="w-4 h-4 rounded"
                            style={{
                                background: item.color,
                                border: item.borderColor ? `2px solid ${item.borderColor}` : 'none',
                            }}
                        />
                        <p className="text-white ml-2 hover:text-[#d99e63]">{item.text}</p>
                    </div>
                ))}
            </FilterContent>
            {address && (chain?.id == shibariumChainId || chain?.id == puppyNetChainId) ?
                <BridgeWrapper>
                    <a href="https://shibarium.shib.io/bridge" target="_blank" rel="noopener noreferrer" className="flex items-center justify-center w-full rounded-full border border-1 border-[#404040] bg-black/50  px-6 py-2  sm:px-6 sm:py-2 text-center text-xs md:text-sm font-semibold text-white shadow-lg hover:bg-black focus:outline-none">
                        Bridge land to Shibarium
                    </a>
                </BridgeWrapper> : null}


        </FilterPanel>
    );
};

export default React.memo(MapFilter);